// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"297":"41cf64a536a3f876","5012":"f9d1d23ca02a821d"}[chunkId] + ".js";
};